query aiSettings {
  aiSettings {
    targetGroup
    tonality
    formality
    perspective
    contentCreatorSettings {
      useHashtags
    }
  }
}
